/**
 * 首页 Hero 区 React 动画入口
 * 打包为 dist/hero-animation.js，仅在首页通过 header.php 的 #react-hero-animation 挂载
 */
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { hyperspeedPresets } from "./HyperSpeedPresets";
import Hyperspeed from "./Hyperspeed";

import ShapeBlur from './ShapeBlur';
// import TrueFocus from './TrueFocus';
// import GradientText from './GradientText'
import NewText from './NewText'
import LightRays from './LightRays';
import './hero-buttons.css';
// For a smoother animation, the gradient should start and end with the same color



/**
 * Hero 根组件：包含 Hyperspeed（1080x1080 居中）+ 可选其它装饰
 * 对应 header.php 中 <div id="react-hero-animation"> 的挂载内容
 */
function HeroRoot() {
    const wrapperStyle = {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        minHeight: "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
    };

    // 增加作为视觉装饰的 ShapeBlur 动画图层，位于 Hyperspeed 底层
    // 保持与 Hyperspeed 一致的尺寸与布局（绝对定位）
    // 可根据实际需求调整参数
    // const shapeBlurStyle = {
    //     position: "absolute",
    //     top: 0,
    //     left: 0,
    //     width: "100%",
    //     height: "100%",
    //     zIndex: 0, // 确保在 Hyperspeed 下层
    //     pointerEvents: "none", // 防止拦截交互
    // };

    /**
     * 连接不能点击/没有鼠标效果，
     * 很可能是被上层某层（如 Three.js Canvas/特效层）“挡住”或 pointer-events 被影响。
     * 解决办法：
     * - 给装饰层（如 LightRays）加 pointerEvents: 'none'
     * - 容器不要加 pointer-events: none
     * - 按钮/链接等需要交互的元素需保证在高 z-index，且没有 pointer-events: none
     * - 尽量避免父节点设置 pointer-events: none 影响所有后代
     */
    // return React.createElement(
    //     "div",
    //     { style: wrapperStyle },
    //     // 注意给装饰背景类加 pointerEvents: "none"，避免“挡住”后面的内容
    //     React.createElement(LightRays, { className: "light-rays-container", style: { pointerEvents: "none" } }),
    //     React.createElement(
    //         "div",
    //         {

    //             className: "new-text-wrapper"
    //         },
    //         React.createElement(NewText, {
    //             text: "《2025/2026玉米出口货物品质报告》 正式发布"
    //         })
    //     ),
    // );
}

/**
 * 挂载到 header.php 中的 #react-hero-animation 容器
 * 供内联脚本调用：window.renderHeroAnimation(document.getElementById('react-hero-animation'))
 * React 18 使用 createRoot 替代已废弃的 ReactDOM.render
 */
function renderHeroAnimation(container) {
    if (!container) return;
    const root = createRoot(container);
    root.render(React.createElement(HeroRoot));
}

// 暴露给全局，供 header.php 内联脚本或其它脚本调用
window.renderHeroAnimation = renderHeroAnimation;

// 等 DOM 与首帧布局完成后再挂载，保证 #lights 有尺寸（Three.js 需要 container.offsetWidth/Height）
function mountHeroAnimation() {
    var container = document.getElementById("react-hero-animation");
    if (container) renderHeroAnimation(container);
}
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        requestAnimationFrame(mountHeroAnimation);
    });
} else {
    requestAnimationFrame(mountHeroAnimation);
}
